import { render, staticRenderFns } from "./SharedPlainBtn.vue?vue&type=template&id=5bb4ff58&"
import script from "./SharedPlainBtn.vue?vue&type=script&lang=js&"
export * from "./SharedPlainBtn.vue?vue&type=script&lang=js&"
import style0 from "./SharedPlainBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports